// @flow
import * as React from 'react';

import { Menu, MenuIcon, MenuItem } from '../menu';

import { FormattedMessage } from 'react-intl';
import generalIcons from '~/core/constants/icons/general-svg';
import interlaceItems from '../interlace-items';
import type { MenuInsertions } from '~/core/types';
import messages from '~/core/i18n/components/bulbs/intl';
import { noop } from 'lodash/fp';
import { StyledSpan } from '../styles';

type Props = {
    additionalItems?: MenuInsertions,
    isOn: boolean,
    isSmall?: boolean,
    isTuneable: boolean,
    canChangeToWhite: boolean,
    switchPicker: noop,
    temperaturePickerActive: boolean,
    toggleDimmer: noop,
    toggleWhite: noop
};

const PickerMenu = ({
    additionalItems = [],
    isOn,
    isSmall,
    isTuneable,
    canChangeToWhite,
    switchPicker,
    temperaturePickerActive,
    toggleDimmer,
    toggleWhite
}: Props) => {
    const switchMessage = temperaturePickerActive ? messages.pickerColor : messages.pickerTuneable;
    const colorPickerItems = isTuneable
        ? [
              <MenuItem enabled={isOn} key="color-picker" onClick={isOn && switchPicker}>
                  {temperaturePickerActive ? (
                      <MenuIcon type={generalIcons.COLOR_PICKER} />
                  ) : (
                      <MenuIcon type={generalIcons.CIRCLE_OUTLINE} />
                  )}
                  <FormattedMessage {...switchMessage}>
                      {message => <StyledSpan>{message}</StyledSpan>}
                  </FormattedMessage>
              </MenuItem>
          ]
        : [];
    const whiteItems = canChangeToWhite
        ? [
              <MenuItem enabled={isOn} key="white" onClick={isOn && toggleWhite}>
                  <MenuIcon type={generalIcons.TONE} />
                  <FormattedMessage {...messages.pickerWhite}>
                      {message => <StyledSpan>{message}</StyledSpan>}
                  </FormattedMessage>
              </MenuItem>
          ]
        : [];
    const defaultItems = colorPickerItems.concat(whiteItems).concat(
        <MenuItem enabled={isOn} key="dimmer" onClick={isOn && toggleDimmer}>
            <MenuIcon type={generalIcons.DIMMER} />
            <FormattedMessage {...messages.pickerDimmer}>
                {message => <StyledSpan>{message}</StyledSpan>}
            </FormattedMessage>
        </MenuItem>
    );

    return <Menu isSmall={isSmall}>{interlaceItems(defaultItems, additionalItems)}</Menu>;
};

export default PickerMenu;



// WEBPACK FOOTER //
// ./src/components/bulbs/color-tuneable/picker-menu.js